module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLightItalic.6885cd4.ttf";